import { connect } from 'react-redux';
import { Footer } from '../../components';

const mapStateToProps = state => {
  return {
    showFooter: state.globalState.showFooter
  };
}

export default connect(mapStateToProps)(Footer);